(function () {
  Flint.file('mframework/views/videoThumbnail.js', function (require) {
    Flint.staticStyles('VideoThumbnail', {
      '$': '#_flintapp .ViewVideoThumbnail',
      '$Loader': '#_flintapp .ViewVideoThumbnail .ViewLoader',
      '$img': '#_flintapp img.VideoThumbnail, #_flintapp .VideoThumbnail.img, #_flintapp .ViewVideoThumbnail.img, #_flintapp .VideoThumbnail > .img'
    }, {
      '$': {
        borderRadius: 8,
        alignItems: 'center',
        justifyContent: 'center'
      },
      '$Loader': {
        opacity: 0.1
      },
      '$img': {}
    });
    Flint.view('VideoThumbnail', function (view, on, $) {
      var pro = initPro(view, {
        videoKey: M.requiredAtom(),
        width: M.defaultAtom(50),
        height: M.defaultAtom(50),
        circle: M.defaultAtom(false)
      });

      var wistiaId = derivation(function () {
        return pro.videoKey.get().split('/')[2];
      });

      var oEmbedUrl = derivation(function () {
        return '//fast.wistia.net/oembed?url=http://home.wistia.com/medias/' + wistiaId.get();
      });

      var thumbnailUrl = atom();

      fetch(oEmbedUrl.get()).then(function (response) {
        return response.json();
      }).then(function (videoJson) {
        if (videoJson.thumbnail_url) {
          thumbnailUrl.set(videoJson.thumbnail_url.replace(/\bimage_crop_resized=(\d+)x(\d+)\b/, 'image_crop_resized=' + Math.ceil(pro.width.get()) + 'x' + Math.ceil(pro.height.get())));
        } else {
          thumbnailUrl.set(null);
        }
      })['catch'](function (err) {
        console.error("Video thumbnail fetch error:", err);
        thumbnailUrl.set(null);
      });view.render(function () {
        return Flint.iff(thumbnailUrl.get() === undefined) && view.el(['Loader', 1], { if: thumbnailUrl.get() === undefined });
      });view.render(function () {
        return Flint.iff(thumbnailUrl.get()) && view.el(['img', 1], { if: thumbnailUrl.get(), src: thumbnailUrl.get() });
      });

      $["$"] = function (_, _index) {
        return {
          width: pro.width.get(),
          height: pro.height.get() };
      };

      'bf0c32a6';

      $["img"] = function (_, _index) {
        return {
          width: pro.width.get(),
          height: pro.height.get(),
          borderRadius: pro.circle.get() ? '50%' : 8
        };
      };
    });
  })
})();
//# sourceMappingURL=videoThumbnail.js.map
